module.exports = __webpack_public_path__ + "img/company.591dcd8d.jpg";